import React from "react";
import { TemplateFilesStatistics } from "../../models/Statistics/TemplateFilesStatistics";
import StatisticsCard from "../common/StatisticsCard";
import { CHART_COLORS } from "../../constants/ChartColors";

interface TemplatesStatisticsCardProps {
  statistics: TemplateFilesStatistics;
}

const TemplatesStatisticsCard: React.FC<TemplatesStatisticsCardProps> = ({
  statistics,
}) => {
  const caseChartData = [
    {
      name: "Migrated",
      value: statistics.templateLibrariesMigrated,
      color: CHART_COLORS.migrated,
    },
    {
      name: "In Progress",
      value: statistics.templateLibrariesInProgress,
      color: CHART_COLORS.inProgress,
    },
    {
      name: "Interrupted",
      value: statistics.templateLibrariesInterrupted,
      color: CHART_COLORS.interrupted,
    },
    {
      name: "Not Started",
      value:
        statistics.numberOfTemplateLibraries -
        (statistics.templateLibrariesMigrated +
          statistics.templateLibrariesInterrupted +
          statistics.templateLibrariesInProgress +
          statistics.templateLibrariesFlagged),
      color: CHART_COLORS.notStarted,
    },
    {
      name: "Flagged",
      value: statistics.templateLibrariesFlagged,
      color: CHART_COLORS.flagged,
    },
  ];
  const filesChartData = [
    {
      name: "Migrated",
      value: statistics.filesMigrated,
      color: CHART_COLORS.migrated,
    },
    {
      name: "Not Found",
      value: statistics.filesNotFound,
      color: CHART_COLORS.inProgress,
    },
    {
      name: "Not Found (Marked For Retry)",
      value: statistics.filesNotFoundMarkedForRetry,
      color: CHART_COLORS.acknowledged,
    },
    {
      name: "Interrupted Initial",
      value: statistics.filesInterruptedInitial,
      color: CHART_COLORS.interrupted,
    },
    {
      name: "Interrupted Delta",
      value: statistics.filesInterruptedDelta,
      color: CHART_COLORS.interruptedDelta,
    },
    {
      name: "Modified",
      value: statistics.filesModified,
      color: CHART_COLORS.modified,
    },
    {
      name: "Not Started",
      value: Math.max(0,
        statistics.totalNumberOfFiles -
        (statistics.filesMigrated +
          statistics.filesInterruptedInitial +
          statistics.filesInterruptedDelta +
          statistics.filesModified +
          statistics.filesNotFound +
          statistics.filesNotFoundMarkedForRetry +
          statistics.filesFlagged +
          statistics.templateFilesUnresolvedConflictCount +
          statistics.templateFilesAcknowledgedConflictCount)),
      color: CHART_COLORS.notStarted,
    },
    {
      name: "Blocked by conflict",
      value: statistics.templateFilesUnresolvedConflictCount,
      color: CHART_COLORS.blockedByConflict,
    },
    {
      name: "Acknowledged conflict",
      value: statistics.templateFilesAcknowledgedConflictCount,
      color: CHART_COLORS.acknowledgedConflict,
    },
  ];
  const flagsChartData = [
    {
      name: "Blocked by user",
      value: statistics.filesInTemplateLibrariesBlockedByUser,
      color: CHART_COLORS.blockedByUser,
    }
  ];

  return (
    <StatisticsCard
      migrationChartData={{ data: caseChartData, label: "Template Libraries" }}
      filesChartData={{ data: filesChartData, label: "Files" }}
      fileFlagsChartData={{ data: flagsChartData, label: "Flags"}}
      title={"Template Files Statistics"}
      totalFilesSizeInGb={statistics.totalFilesSizeInGb}
      totalMigratedFilesSizeInGb={statistics.totalMigratedFilesSizeInGb}
      totalFilesSizeInMb={statistics.totalFilesSizeInMb}
      totalMigratedFilesSizeInMb={statistics.totalMigratedFilesSizeInMb}
      notFoundFilesSizeInGb={statistics.notFoundTemplateFilesSizeInGb || 0}
      notFoundFilesSizeInMb={statistics.notFoundTemplateFilesSizeInMb || 0}
      interruptedFilesSizeInGb={(statistics.interruptedInitialTemplateFilesSizeInGb || 0) + (statistics.interruptedDeltaTemplateFilesSizeInGb || 0)}
      interruptedFilesSizeInMb={(statistics.interruptedInitialTemplateFilesSizeInMb || 0) + (statistics.interruptedDeltaTemplateFilesSizeInMb || 0)}
      showFlaggedSizeInfo={false}
    />
  );
};

export default TemplatesStatisticsCard;
